import { useMemo } from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import Breadcrumbs, { BackButton, BreadcrumbProps } from '@/components/Breadcrumbs';
import useNavigation from '@/hooks/useNavigation';

const TITLE_CLASS_OVERRIDES = { Typography: { color: 'text-text-secondary' } };

const TemplatesHeaderNode = (props: {
  title: string;
  onBack?: () => void;
  isPreview?: boolean;
}) => {
  const { title, onBack, isPreview } = props;

  const { isMobile } = useScreen();

  const { back } = useNavigation();

  const breadcrumbs = useMemo<BreadcrumbProps[]>(
    () => [{ label: title, overrides: TITLE_CLASS_OVERRIDES }],
    [title],
  );

  if (isMobile || isPreview) {
    return null;
  }

  return (
    <Breadcrumbs
      backIcon={<BackButton onClick={onBack || back} />}
      breadcrumbs={breadcrumbs}
      className="ps-10"
    />
  );
};

export default TemplatesHeaderNode;
